import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Outlet, createRootRouteWithContext, useRouter } from "@tanstack/react-router";
import { AppSidebar } from "@/components/AppSidebar";
import { TopBar } from "@/components/TopBar";
import { CommandPalette } from "@/components/CommandPalette";
import { CompanionProvider } from "@/state/CompanionContext";
import { SideRailProvider } from "@/state/SideRail";
import { ActionStoreProvider } from "@/state/ActionStore";

function NotFoundComponent() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-canvas">
      <div className="text-[13px] text-muted-foreground">404 — page not found</div>
    </div>
  );
}

function ErrorComponent({ error, reset }: { error: Error; reset: () => void }) {
  console.error(error);
  const router = useRouter();
  return (
    <div className="flex min-h-screen items-center justify-center bg-canvas">
      <div className="text-center">
        <div className="text-[13px] text-foreground">Something went wrong</div>
        <button
          onClick={() => { router.invalidate(); reset(); }}
          className="mt-3 rounded-sm border border-border bg-background px-3 py-1 text-[12px] hover:bg-muted"
        >
          Retry
        </button>
      </div>
    </div>
  );
}

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: RootComponent,
  notFoundComponent: NotFoundComponent,
  errorComponent: ErrorComponent,
});

function RootComponent() {
  const { queryClient } = Route.useRouteContext();
  return (
    <QueryClientProvider client={queryClient}>
      <ActionStoreProvider>
        <CompanionProvider>
          <SideRailProvider>
            <div className="flex h-screen w-full overflow-hidden bg-canvas">
              <AppSidebar />
              <div className="flex min-w-0 flex-1 flex-col">
                <TopBar />
                <main className="min-h-0 flex-1 overflow-hidden">
                  <Outlet />
                </main>
              </div>
              <CommandPalette />
            </div>
          </SideRailProvider>
        </CompanionProvider>
      </ActionStoreProvider>
    </QueryClientProvider>
  );
}
